<template>
    <div class="ls_spin_container">
        <Row class="pt-20">
            <Col :xs="24" :sm="24" :md="24" :lg="19" :xl="21">
                <Row :gutter="24" type="flex">


                    <Col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" v-for="el of data" :key="el.id" class="mb-70">

                        <div class="card-container__common" :class="{flip: el.flip === true}">

                            <Card class="card-container front__side">
                                <h2
                                        style="cursor: pointer"
                                        class="item_card_header mb-15"
                                        @click="$router.push({
                                    name: item_type + '_detail',
                                    params: { id: el.id }
                                })">
                                    {{ el.name }}
                                </h2>

                                <p class="fs-15 color-grey mb-24">
                                    Создан
                                    {{ formatDateTime(el.created_date) }}
                                </p>
                                <p class="fs-15">
                                    Заводской номер:
                                    <b v-if="el.manufacturer_number != null">{{el.manufacturer_number}}</b>
                                    <b v-else>-</b>
                                </p>
                                <p class="fs-15">
                                    Дата окончания тарифа:
                                    <b v-if="el.expiration_date != null">{{formatDate(el.expiration_date)}}</b>
                                    <b v-else>-</b>
                                </p>
                                <p class="fs-15">
                                    ОФД:
                                    <b v-if="el.ofd_server_display != '' ">{{el.ofd_server_display}}</b>
                                    <b v-else>-</b>
                                </p>
                                <p class="fs-15 mb-24">
                                    Статус кассы: <b>{{el.ofd_status_display}}</b>
                                </p>
                                <p class="fs-15 mb-24">
                                    Язык в фискальном чеке: <b>{{ el.receipt_lang_display }}</b>
                                </p>
                                <p class="fs-15 mb-24">
                                    Наличные в кассе:
                                    <b>{{ formatNumber(el.balance) }} {{ currency }}</b>
                                </p>
                            </Card>

                            <Card class="card-container back__side">
                                <h2
                                        style="cursor: pointer"
                                        class="item_card_header mb-15"
                                        @click="$router.push({
                                    name: item_type + '_detail',
                                    params: { id: el.id }
                                })">
                                    {{ el.name }}
                                </h2>
                                <p class="fs-15 color-grey mb-24">
                                    Создан
                                    {{ formatDateTime(el.created_date) }}
                                </p>
                                <p class="fs-15">
                                    Заводской номер:
                                    <b>Товарная</b>
                                </p>
                                <p class="fs-15 mb-24">
                                    Наличные в кассе:
                                    <b>{{ formatNumber(el.nonfiscal_balance) }} {{ currency }}</b>
                                </p>
                            </Card>


                            <div class="action_buttons">

                                <Tooltip content="Изменить токен" placement="top"
                                         v-if="el.nonfiscal_tooltip === 'Показать товарную кассу'">
                                    <Button type="info" class="cursor-pointer"
                                            @click="cash_to_token = el, modal_2 = true">
                                        <img src="/static/svg/change_token.svg" alt="">
                                    </Button>
                                </Tooltip>

                                <Tooltip content="Закрыть кассу" placement="top">
                                    <Button v-if="el.show_close_btn && el.nonfiscal_tooltip === 'Показать товарную кассу'"
                                            type="primary" class="cursor-pointer"
                                            @click="cash_to_close = el.id, modal = true">
                                        <img src="/static/svg/close.svg" alt="">
                                    </Button>
                                </Tooltip>

<!--                                <Tooltip content="Удалить кассу" placement="top">-->
<!--                                    <Button type="error" @click="deleteCash(el.id, el.name)">-->
<!--                                        <Icon size="24" type="md-trash"/>-->
<!--                                    </Button>-->
<!--                                </Tooltip>-->

                                <Tooltip content="Добавить товарную кассу" placement="top" v-if="el.use_nonfiscal === false">
                                    <Button type="success" @click="modal_4 = true, cash_to_useNonfiscal = el.id">
                                        <Icon size="24" type="md-add"/>
                                    </Button>
                                </Tooltip>
                            </div>


                            <div class="top__button">
                                <Tooltip :content="el.nonfiscal_tooltip"
                                         placement="left"
                                         v-if="el.use_nonfiscal === true">
                                    <Button type="primary" @click="flipCard(el)">
                                        <img src="/static/svg/cash.svg" alt="">
                                    </Button>
                                </Tooltip>
                            </div>


                            <Row :gutter="16">
                                <Col span="7" class="item_card_image">
                                </Col>
                                <Col span="17">
                                    <Row>
                                        <Col :xs="24" :sm="24" :md="24" :lg="13">

                                        </Col>
                                        <Col :xs="24" :sm="24" :md="24" :lg="11">
                                            <Tag v-if="el.deleted_date" color="error" style="float: right;">Удален</Tag>
                                        </Col>
                                    </Row>

                                    <div class="item_card_content">

                                        <!--<p v-if="el.address"><Icon type="ios-pin-outline" /> {{ el.address }}</p>-->
                                        <!--<p v-if="el.description">-->
                                        <!--<Icon type="ios-clipboard-outline" /> {{ el.description }}-->
                                        <!--</p>-->
                                    </div>
                                </Col>
                                <div class="item_actions">
                                    <Button
                                            v-if="display_edit_button"
                                            type="primary"
                                            ghost
                                            @click="
                  $router.push({
                    name: item_type + '_edit',
                    params: { id: el.id }
                  })
                "
                                    >
                                        <Icon
                                                type="ios-create-outline"
                                                size="16"
                                        />
                                        Редактировать
                                    </Button
                                    >
                                    <Button
                                            v-if="display_delete_button"
                                            type="error"
                                            ghost
                                            @click="deleteItem(el.id)"
                                    >
                                        <Icon type="ios-trash-outline" size="16"/>
                                        Удалить
                                    </Button
                                    >
                                </div>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Col>
            <Col :sm="24" :xs="24" :md="24" :lg="5" :xl="3" align="right">
                <Button
                        v-if="display_create_button"
                        type="info"
                        class="ls_create_button"
                        :to="{ name: item_type + '_create' }"
                >Создать
                    <Icon type="ios-create-outline"/>
                </Button>
            </Col>

        </Row>


        <!--Modal for close shift-->
        <Modal
                :footer-hide="footerHide"
                v-model="modal"
                title="">
            <h3 class="mb-40">Вы действительно хотите закрыть смену в кассе?</h3>

            <Row type="flex" justify="center">
                <Button type="info" style="margin-right: 12px"
                        @click="deleteShift(cash_to_close)">
                    ДА
                </Button>
                <Button type="error" @click="modal = false">НЕТ</Button>
            </Row>
        </Modal>


        <!--Modal for edit token-->
        <Modal
                :footer-hide="footerHide"
                v-model="modal_2"
                title="">

            <h3 class="mb-40">Изменение токена для кассы " {{cash_to_token.name}}"</h3>

            <div class="mb-40">
                <Label>Токен для отправки данных в ОФД</Label>
                <Input
                        placeholder="Введите значение"
                        v-model="new_token">
                </Input>
            </div>

            <Row type="flex" justify="center">
                <Button :disabled="!new_token" type="info" style="margin-right: 12px"
                        @click="modal_3 = true">
                    Сохранить
                </Button>
                <Button type="error" @click="modal_2 = false">Отмена</Button>
            </Row>
        </Modal>


        <!--Modal for check token-->
        <Modal
                :footer-hide="footerHide"
                v-model="modal_3"
                title="">

            <h3 class="mb-40">Вы действительно хотите изменить токен?</h3>

            <Row type="flex" justify="center">
                <Button type="info" style="margin-right: 12px"
                        @click="changeToken(cash_to_token.id)">
                    Да
                </Button>
                <Button type="error" @click="cancelToken()">Нет</Button>
            </Row>
        </Modal>


        <!--Modal for add use_nonfiscal-->
        <Modal
                :footer-hide="footerHide"
                v-model="modal_4"
                title="">

            <h3 class="mb-40">Вы действительно хотите создать товарную кассу?</h3>

            <Row type="flex" justify="center">
                <Button type="error" style="margin-right: 12px" @click="modal_4 = false">Отмена</Button>
                <Button type="success"
                        @click="changeUseNonfiscal(cash_to_useNonfiscal)">
                    Создать
                </Button>
            </Row>
        </Modal>


        <!--    &lt;!&ndash;Modal for edit cashe&ndash;&gt;-->
        <!--    <Modal-->
        <!--      :footer-hide="footerHide"-->
        <!--      v-model="modal_4"-->
        <!--      title="">-->
        <!--      <h3 class="mb-40">Вы действительно хотите удалить кассу "{{cash_to_delete.name}}"?</h3>-->

        <!--      <Row type="flex" justify="center">-->
        <!--        <Button type="info" style="margin-right: 12px"-->
        <!--                @click="deleteCash(cash_to_delete.id)">-->
        <!--          ДА-->
        <!--        </Button>-->
        <!--        <Button type="error" @click="modal_4 = false">НЕТ</Button>-->
        <!--      </Row>-->
        <!--    </Modal>-->


        <cashItem
                :id="item.id"
                :action="item.action"
                v-model="item.show"
                @reload-table="fetchItems"
                :base_view_url="baseViewUrl"
                :item_type="item_type"
        ></cashItem>


        <!--Modal for remove Item-->
        <Modal
                :footer-hide="footerHide"
                v-model="removeModal"
                title="">

            <h3 class="mb-40">Вы действительно хотите удалить данную кассу?</h3>

            <Row type="flex" justify="center">
                <Button type="error" @click="removeModal = false">Отмена</Button>
                <Button type="success" style="margin-left: 12px"
                        @click="deleteItem(removeId)">
                    Удалить
                </Button>
            </Row>
        </Modal>


        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
    import {base_url, server_addr} from "../../http.js";
    import cashItem from "@/apps/cash/cashItem.vue";
    import cardColumn from "@/components/core/cardColumn.vue";
    import {BaseCardListData} from "../../base/base_card_list.js";


    let _app = BaseCardListData();
    _app.components = {
        cashItem,
        cardColumn
    };

    _app.data = function () {
        return {
            // Base settings
            baseViewUrl: base_url + "/cashes/",
            item_type: "cash",
            loading: true,

            data: [],
            item_image_url: "./static/img/cashbox_89x89.png",

            modal: false,
            modal_2: false,
            modal_3: false,
            modal_4: false,
            footerHide: true,

            cash_to_close: null,
            cash_to_token: {},
            cash_to_delete: {},
            cash_to_useNonfiscal: null,

            new_token: null,

            item: {
                show: false,
                id: null,
                action: null
            },

            removeModal: false,
            removeId: null,
        };
    };

    _app.methods.current_shift = function () {

        this.data.forEach(data => {
            const url = base_url + '/cashes/' + data.id + '/current_shift/';
            this.$http
                .get(url)
                .then(response => {
                    data.show_close_btn = true;
                })
                .finally(() => {
                });
        });

    };


    _app.methods.deleteShift = function (id) {

        const url = base_url + '/cashes/' + id + '/shift/';
        this.$http
            .delete(url)
            .then(response => {
                this.$Notice.open({
                    title: 'Уведомление',
                    desc: 'Смена на кассе успешно закрыта'
                });
                this.fetchItems();
            })
            .finally(() => {
                this.modal = false;
            })
            .catch(error => {
                // this.$Notice.open({
                //     title: 'Ошибка',
                //     desc: 'Нет открытых смен'
                // });
            })

    };

    _app.methods.changeToken = function (id) {
        const url = base_url + '/cashes/' + id + '/token/';
        this.$http
            .put(url, {
                'token': this.new_token
            })
            .then(response => {
                this.$Notice.open({
                    title: 'Уведомление',
                    desc: 'Токен успешно изменен!'
                });

            })
            .finally(() => {
                this.cancelToken();
            })
            .catch(error => {
                this.$Notice.open({
                    title: 'Ошибка',
                    desc: 'Произошла ошибка. Обратитесь в службу поддержки.'
                });

            })
    };

    _app.methods.deleteCash = function (id, type) {
        const url = base_url + '/cashes/' + id + '/current_shift/';
        this.$http
            .get(url)
            .then(response => {
                this.$Notice.open({
                    title: 'Ошибка',
                    desc: 'Для удаления кассы необходимо закрыть смену'
                });
            })
            .catch(error => {
                this.removeId = id;
                this.removeModal = true;
            })
            .finally(() => {
            });
    };

    _app.methods.changeUseNonfiscal = function (id) {
        const url = base_url + '/cashes/' + id + '/nonfiscal/';
        this.$http
            .put(url, {
                use_nonfiscal: true
            })
            .then(response => {
                this.fetchItems();
            })
            .catch(error => {

            })
            .finally(() => {
                this.modal_4 = false;
            });

    };

    _app.methods.flipCard = function (el) {
        let tooltip_1 = 'Показать товарную кассу';
        let tooltip_2 = 'Скрыть товарную кассу';

        this.data.forEach(item => {
            if(item.id === el.id) {
                item.flip = !item.flip;
                if(item.nonfiscal_tooltip === tooltip_1) return item.nonfiscal_tooltip =  tooltip_2;
                if(item.nonfiscal_tooltip === tooltip_2) return item.nonfiscal_tooltip =  tooltip_1;
            }
        })
    };


    _app.methods.cancelToken = function () {
        this.modal_2 = false;
        this.modal_3 = false;
        this.new_token = null
    };



    export default _app;
</script>

<style scoped>

    .pt-20 {
        padding-top: 20px;
    }

    .mb-70 {
        margin-bottom: 70px;
    }

    .action_buttons {
        display: flex;
        justify-content: center;
        position: absolute;
        z-index: 5;
        bottom: -20px;
        left: 50%;
        transform: translateX(-50%);
    }

    .action_buttons button, .top__button button {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        padding: 0;
        margin: 0 6px;
    }

    .top__button {
        position: absolute;
        z-index: 5;
        top: -20px;
        right: -20px;
    }

    .card-container__common {
        position: relative;
    }

    .card-container__common .front__side {
        transition: 0.4s ease;
    }

    .card-container__common .back__side {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        visibility: hidden;
        transform: rotateY(-180deg);
    }

    .card-container__common.flip .front__side{
        transform: rotateY(180deg);
        opacity: 0;
        visibility: hidden;
    }

    .card-container__common.flip .back__side{
        opacity: 1;
        visibility: visible;
        transform: rotateY(0);
    }


    @media screen and (max-width: 767px) {
        .card-container p.mb-24 {
            margin-bottom: 5px;
        }

        .card-container p {
            font-size: 10px;
        }
    }


    @media screen and (max-width: 575px) {

        .ls_create_button {
            width: 100%;
        }
    }
</style>


<style>
    .action_buttons button span {
        width: 22px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: auto;
    }
</style>



// WEBPACK FOOTER //
// src/apps/cash/cash.vue